/* global __webpack_nonce__ */
import { getCspNonce } from "@/utils/cspNonce";

const nonce = getCspNonce();

if (nonce) {
  __webpack_nonce__ = nonce;

  const isPatched = document.createElement.__cspNoncePatched;

  if (!isPatched) {
    const createElement = document.createElement.bind(document);

    document.createElement = (tagName, options) => {
      const element = createElement(tagName, options);

      if (String(tagName).toLowerCase() === "style") {
        element.setAttribute("nonce", nonce);
      }

      return element;
    };

    document.createElement.__cspNoncePatched = true;
  }
}
